// updateOrderByPusher only maps orders already listed, so one entering the filter stays invisible.
export const shouldRefetchOnPusherStatus = ({
  order,
  list,
  ordersFilter,
  ordersLoading,
  hasQueuedNewOrders
}) => {
  if (ordersLoading || hasQueuedNewOrders || !order?.status || !Array.isArray(list)) {
    return false;
  }
  if (!ordersFilter.includes(order.status)) {
    return false;
  }
  return !list.some(({ id }) => id === order.id);
};
